import { Node, mergeAttributes } from '@tiptap/core';

export const LetterPlaceholderExtension = Node.create({
  name: 'letterPlaceholder',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      key: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-key'),
        renderHTML: (attributes) => ({
          'data-key': attributes.key,
        }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-letter-placeholder]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        'data-letter-placeholder': 'true',
        class: 'letter-placeholder-chip',
      }),
      node.attrs.key || '',
    ];
  },

  addCommands() {
    return {
      insertLetterPlaceholder:
        (key) =>
        ({ chain, state }) => {
          const { selection, storedMarks } = state;
          const activeMarks = storedMarks || selection.$from.marks();
          const marks = activeMarks.filter((mark) =>
            ['bold', 'italic', 'strike', 'letterFont', 'letterFontSize'].includes(mark.type.name),
          );
          return chain()
            .focus()
            .insertContent({
              type: this.name,
              attrs: { key },
              marks: marks.map((mark) => {
                if (mark.type.name === 'letterFont') {
                  return { type: mark.type.name, attrs: { family: mark.attrs.family } };
                }
                if (mark.type.name === 'letterFontSize') {
                  return { type: mark.type.name, attrs: { pt: mark.attrs.pt } };
                }
                return { type: mark.type.name };
              }),
            })
            .run();
        },
    };
  },
});

export default LetterPlaceholderExtension;
